import { lazy } from 'react';
/** Открывает список прайс-листов */
export const PriceListsPageAsync = lazy(() => import('./PriceLists/PriceListsPage'));